export default {
  staff: 1,
  vendor: 2,
  lab: 3,
  accountant: 4
};



// WEBPACK FOOTER //
// ./src/dictionaries/UserRoles.js